import { useViewStickers } from "../../../../hooks/sticker_types/useViewStickers";
import {
  API_ASSET_STATUS_UPDATES_REPORT,
  API_ASSET_STOCK_VARIANCE_REPORT,
  API_ASSET_TRANSFERS_REPORT,
  API_ASSETS_REPORT,
  API_WAGE_ADVANCEMENTS_REPORT,
  API_WAGE_CALCULATIONS_REPORT,
  API_WAGES_REPORT,
  API_WEEKLY_COLLECTIONS_REPORT,
} from "../../../../utils/apis";
import {
  AGING_REPORT_API,
  API_AGENT_DEFAULTER_PERFORMANCE_REPORTS,
  API_AGENT_DEPOSIT_PERFORMANCE_REPORTS,
  API_AGENT_PERFORMANCE_REPORTS,
  API_COUPON_SALES_REPORTS,
  API_REVENUE_PERFORMANCE_SOURCE_REPORTS,
  BOOKING_ADHOC_API,
  ECOUPON_ADHOC_API,
  INVOICES_ADHOC_API,
  LEDGER_REPORT_ADHOC_API,
  PARKED_CARS_ADHOC_API,
  PARKING_SLOTS_OCCUPANCY_API,
  PAYMENTS_ADHOC_API,
  PAYMENTS_REPORT_API,
  REVENUE_PERFORMANCE_ADHOC_API,
} from "../../../../utils/constants";

import { useLedgerReport } from "./useAdhocReport";
import useAgentDefaultersReport from "./useAgentDefaultersReport";
import useAgentDepositsPerformance from "./useAgentDepositsPerformanceReport";
import { useAgentPerformanceReports } from "./useAgentPerformance";
import useAgingReport from "./useAgingReport";
import useBookingAdhoc from "./useBookingAdhoc";
import { useCouponSalesReport } from "./useCouponSalesReport";
import useOccupancyReport from "./useOccupancyReport";
import useParkedCarsAdhoc from "./useParkedCarsadhoc";
import usePaymentsReport from "./usePaymentsReport";
import useRevenuePerformance from "./useRevenuePerformanceReport";
import useRevenueSourcePerformance from "./useRevenueSourcePerformance";
import useWagesReport from "./useWagesReport";
import {
  useAssetStatusUpdatesReport,
  useAssetStockVarianceReport,
  useAssetTransfersReport,
  useAssetsReport,
} from "./useAssetReports";
import {
  useWageAdvancementsReport,
  useWageCalculationsReport,
  useWeeklyCollectionsReport,
} from "./useWageReports";

export const adhocRegisterHooks = {
  ledger_report: useLedgerReport,
  parking_occupancy_report: useOccupancyReport,
  coupon_sales_report: useCouponSalesReport,
  booking_adhoc: useBookingAdhoc,
  parked_cars_adhoc: useParkedCarsAdhoc,
  revenue_performance: useRevenuePerformance,
  revenue_source_performance: useRevenueSourcePerformance,
  agent_deposit_performance: useAgentDepositsPerformance,
  agent_defaulter_performance: useAgentDefaultersReport,
  // payments_adhoc: usePaymentsAdhocReport,
  aging_report: useAgingReport,
  agent_performance_report: useAgentPerformanceReports,
  payments_report: usePaymentsReport,
  wages_report: useWagesReport,
  wage_calculations_report: useWageCalculationsReport,
  wage_advancements_report: useWageAdvancementsReport,
  weekly_collections_report: useWeeklyCollectionsReport,
  assets_report: useAssetsReport,
  asset_transfers_report: useAssetTransfersReport,
  asset_status_updates_report: useAssetStatusUpdatesReport,
  asset_stock_variance_report: useAssetStockVarianceReport,
  view_sticker: useViewStickers,
};

export const adhocSourceApis = {
  ledger_report: LEDGER_REPORT_ADHOC_API,
  parking_occupancy_report: PARKING_SLOTS_OCCUPANCY_API,
  booking_adhoc: BOOKING_ADHOC_API,
  parked_cars_adhoc: PARKED_CARS_ADHOC_API,
  invoices_adhoc: INVOICES_ADHOC_API,
  ecoupon_adhoc: ECOUPON_ADHOC_API,
  revenue_performance: REVENUE_PERFORMANCE_ADHOC_API,
  payments_adhoc: PAYMENTS_ADHOC_API,
  aging_report: AGING_REPORT_API,
  agent_performance_report: API_AGENT_PERFORMANCE_REPORTS,
  revenue_source_performance: API_REVENUE_PERFORMANCE_SOURCE_REPORTS,
  agent_deposit_performance: API_AGENT_DEPOSIT_PERFORMANCE_REPORTS,
  agent_defaulter_performance: API_AGENT_DEFAULTER_PERFORMANCE_REPORTS,
  coupon_sales_report: API_COUPON_SALES_REPORTS,
  payments_report: PAYMENTS_REPORT_API,
  wages_report: API_WAGES_REPORT,
  wage_calculations_report: API_WAGE_CALCULATIONS_REPORT,
  wage_advancements_report: API_WAGE_ADVANCEMENTS_REPORT,
  weekly_collections_report: API_WEEKLY_COLLECTIONS_REPORT,
  assets_report: API_ASSETS_REPORT,
  asset_transfers_report: API_ASSET_TRANSFERS_REPORT,
  asset_status_updates_report: API_ASSET_STATUS_UPDATES_REPORT,
  asset_stock_variance_report: API_ASSET_STOCK_VARIANCE_REPORT,
};
